export default __webpack_public_path__ + "static/media/Copy of 25-dont-store-customer-data.a555c83e.jpg";